import { css } from '@emotion/react';
import styled from '@emotion/styled';

import {
  cloudyBlue,
  darkGrey,
  fontWeight,
  sizeMobile,
  sizeMobileUp,
  sizeTablet,
  sizeTabletMin,
  standardPaddingMd,
  typeYgiCreateAccountDivider,
} from '~/styles';

// ygi-login
export const SignInMain = styled.div`
  width: 100%;
  max-width: 461px;
  padding: 24px 10px 52px;

  .ygi-form-group {
    padding: 0;
  }
  ${sizeTablet(css`
    max-width: unset;
    padding: 16px 10px;
  `)};
  ${sizeMobile(css`
    padding: 5px 10px 10px;
  `)}
`;

// ygi-login__forgot-password
export const SignInForgotPassword = styled.a`
  font-size: 16px;
  font-weight: ${fontWeight.regular};
  line-height: 20px;
  letter-spacing: 0.05em;
  text-align: center;
  color: ${darkGrey};
  margin-top: 32px;
`;

// ygi-login-divider
export const SignInFormDivider = styled.div`
  position: relative;
  max-width: 366px;
  height: 1px;
  background-color: ${cloudyBlue};
  margin: auto;

  &::before {
    ${typeYgiCreateAccountDivider};

    content: 'OR';
    position: absolute;
    top: -6.25px;
    left: calc(50% - 36.5px);
    width: 73px;
    height: 25px;
    text-align: center;
    background: #fff;
  }
  ${sizeMobile(css`
    width: 90%;
  `)}
`;

export const SignInWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 16px 8px;
  ${sizeMobileUp(css`
    padding: 32px 16px;
  `)}
  ${sizeTabletMin(css`
    padding: ${standardPaddingMd};
  `)};
`;
